import { createAsyncThunk } from '@reduxjs/toolkit';
import { getRequest } from '../wwlAPI';
import { handleSearchFilters } from './atlasUtils';

export const atlasSearchRecipes = createAsyncThunk(
  'atlas/atlasSearchRecipes',
  async (payload, { getState }) => {
    try {
      const { atlas } = getState();

      let {
        searchTerm,
        dontIncludeIngredients,
        includeIngredients,
        dietType,
        filterKey,
        direction,
        pageNum,
        recipes
      } = atlas;

      const normalizedFilterKey =
        typeof filterKey === 'object' ? filterKey?.value : filterKey || 'score';

      const normalizedDirection =
        typeof direction === 'object' ? direction?.value : direction || 'desc';

      const queryParams = new URLSearchParams({
        searchTerm: searchTerm || '',
        dietType: dietType || '',
        filterKey: normalizedFilterKey,
        direction: normalizedDirection,
        pageNum: payload?.restart ? 1 : pageNum
      });

      includeIngredients.forEach((ingredient) =>
        queryParams.append('includeIngredients[]', ingredient)
      );

      dontIncludeIngredients.forEach((ingredient) =>
        queryParams.append('dontIncludeIngredients[]', ingredient)
      );

      const url = `/recipes/atlasRecipeSearch?${queryParams.toString()}`;
      const response = await getRequest(url);

      const combinedRecipes = [...recipes, ...(response.data.recipes || [])];
      const sortedRecipes = handleSearchFilters(
        combinedRecipes,
        normalizedFilterKey,
        normalizedDirection
      );

      return {
        recipes: sortedRecipes,
        pagination: response.data.pagination
      };
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);